// themes/sepiaVintageTheme.ts
import { createTheme } from "@mui/material/styles";

export const sepiaVintageTheme = createTheme({
    palette: {
        mode: "light",
        background: {
            default: "#D9C3A6", // nền giấy kraft nhạt
            paper: "rgba(255, 255, 255, 0.2)",
        },
        primary: {
            main: "#8B5E3C",   // nâu đất (tone chính)
            light: "#D9C3A6",  // nền nhạt
            dark: "#5C3B24",   // nâu đậm để contrast
            contrastText: "#FFFFFF", // chữ sáng trên nền nâu
        },
        secondary: {
            main: "#D48C3B",        // accent cam đồng
            contrastText: "#FFFFFF" // chữ trắng trên nút cam
        },
        text: {
            primary: "#3B2C20",   // nâu đậm
            secondary: "#5C3B24", // nâu trung bình
        },
    },

    shape: {
        borderRadius: 12,
    },

    typography: {
        fontFamily: '"Orbitron", sans-serif',
        button: {
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "0.9rem",
        },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#D9C3A6",
                    // backgroundImage: `linear-gradient(rgba(217,195,166,0.9), rgba(217,195,166,0.9)), url('/assets/3.jpeg')`,
                    // backgroundImage: `linear-gradient(rgba(217,195,166,0.9), rgba(217,195,166,0.9)), url('/assets/anti_scam_defender.jpg')`,
                    backgroundImage: `linear-gradient(rgb(217 195 166 / 65%), rgb(67 39 3 / 95%)), url(/assets/anti_scam_defender.jpg)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",

                    "& .MuiSideBar": {
                        position: "relative",
                        borderRadius: "12px",
                        backgroundColor: "rgba(139,94,60,0.75)", // nâu đất translucent
                        padding: "16px",
                        width: "100%",
                        maxWidth: "100%",
                        color: "#3B2C20",
                        margin: "0 auto 20px",
                        "& .titleBox": {
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.75)",
                            borderRadius: "8px",
                            padding: "6px 16px",
                            width: "100%",
                            marginBottom: "16px",
                            "& .titleText": {
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                color: "#8B5E3C", // nâu đất
                                letterSpacing: "1px",
                                fontSize: "1rem",
                            }
                        }
                    },

                    "& .MuiMessage": {
                        padding: 24,
                        textAlign: "center",
                        borderRadius: "12px",
                        color: "white",
                        fontFamily: '"Orbitron", sans-serif',
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        letterSpacing: "1px",
                    },

                    "& .CenterButton": {
                        minWidth: "100px",
                        height: "160px",
                        borderRadius: "50%",
                        background: "radial-gradient(circle at 50% 50%, #F5E6D0, #D9C3A6)",
                        border: "2px solid #8B5E3C",
                        boxShadow: "0 6px 18px rgba(139,94,60,.35)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "all 0.25s ease",
                        padding: 0,
                        "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 12px 24px rgba(139,94,60,.45)",
                            "& .MuiSvgIcon-root": {
                                color: "#8B5E3C",
                                filter: "drop-shadow(0 0 8px rgba(139,94,60,0.6))",
                            },
                        },
                        "& .MuiSvgIcon-root": {
                            fontSize: "64px",
                            color: "#3B2C20",
                            transition: "all 0.4s ease",
                        },
                    },
                },
                "*": {
                    boxSizing: "border-box",
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    fontWeight: "bold",
                    fontFamily: '"Orbitron", sans-serif',
                    backgroundColor: "rgba(255,255,255,0.6)", // cam đồng
                    color: "#553c1a",
                    "&:hover": {
                        backgroundColor: "#664f32f0",
                        boxShadow: "0 0 12px #664f32f0",
                        color: "#FFFFFF",
                    },
                    "&:active": {
                        transform: "scale(0.98)",
                        color: "#FFFFFF",

                    },
                    "&.active": {
                        // backgroundColor: '#664f32',
                        backgroundColor: '#553c1a',
                        color: "#FFFFFF",
                        boxShadow: '0 0 12px #664f32'
                    }
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255,255,255,0.25)",
                    borderRadius: 12,
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#D48C3B",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#8B5E3C",
                        boxShadow: "0 0 6px #8B5E3C",
                    },
                    input: {
                        color: "#3B2C20",
                    },
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                    borderRadius: 16,
                    backdropFilter: "blur(6px)",
                    boxShadow: "0 0 6px rgba(139, 94, 60, 0.3)",
                },
            },
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    color: "#3B2C20",
                },
            },
        },

        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#9480659e", // nâu đất
                    color: "#FFFFFF",
                }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    "&.muiButtonIcon": {
                        fill: "#C8A86A"
                    },
                }
            }
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.85)",
                    boxShadow: "0 0 16px rgba(139, 94, 60, 0.6)",
                    padding: "16px 24px",
                    color: "#3B2C20",
                },
            },
        },
    },
});
